export function cloneDeep(obj) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

export function mergeDeep(target = {}, source = {}) {
  const output = Array.isArray(target) ? [...target] : { ...target };
  if (source && typeof source === 'object') {
    Object.keys(source).forEach((key) => {
      const value = source[key];
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        output[key] = mergeDeep(target[key] || {}, value);
      } else {
        output[key] = value;
      }
    });
  }
  return output;
}

export function formatMessage(template, vars = {}) {
  if (!template) return '';
  return template.replace(/\{(\w+)\}/g, (_, key) => (
    Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : `{${key}}`
  ));
}

